const styles = {
  error: {
    margin: '1rem 0 0 0'
  }
}
export default styles
